import { useQuery } from "@tanstack/react-query";
import { useOrg360Api } from "./useOrg360Api";
import type { Org360GraphData } from "@/components/organisms/org360/org360Types";

export interface Org360IncludeFlags {
  fields?: boolean;
  reports?: boolean;
  managed?: boolean;
}

export function useOrg360GraphData(selectedType?: string, include?: Org360IncludeFlags) {
  const { getJson, orgId } = useOrg360Api();
  const inc = {
    fields: !!include?.fields,
    reports: !!include?.reports,
    managed: !!include?.managed,
  };

  return useQuery({
    queryKey: ["org360-graph", orgId, selectedType ?? "all", inc.fields, inc.reports, inc.managed],
    queryFn: async () => {
      const params: Record<string, string | undefined> = {
        org_id: orgId,
        limit: "2500",
        metadata_type: selectedType,
      };
      if (inc.fields) params.include_fields = "1";
      if (inc.reports) params.include_reports = "1";
      if (inc.managed) params.include_managed = "1";
      const res = await getJson<{ ok: boolean; data: Org360GraphData }>("/api/graph", params);
      return res?.data ?? null;
    },
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
